import React, { useState } from "react";
import "./MenuSuperior.css";
import {FaCog,} from "react-icons/fa";

const MenuSuperior = ({ setActiveSection }) => {
  const [activeButton, setActiveButton] = useState("puestos");

  const handleButtonClick = (section) => {
    setActiveButton(section);
    setActiveSection(section);
  };

  return (
    <div className="user-office">
    <nav className="office-menu">
      <button
        className={`${activeButton === "puestos" ? "active" : ""}`}
        onClick={() => handleButtonClick("puestos")}
      >
        Puestos
      </button>
      <button
        className={`${activeButton === "requests" ? "active" : ""}`}
        onClick={() => handleButtonClick('requests')}
      >
        Solic.
      </button>
      <button
        className={`${activeButton === "crm" ? "active" : ""}`}
        onClick={() => handleButtonClick('crm')}
      >
        CRM
      </button>
      <button
        className={`${activeButton === "mensajes" ? "active" : ""}`}
        onClick={() => handleButtonClick("mensajes")}
      >
        <i className={`fa-solid ${activeButton === "mensajes" ? "fa-envelope-open-text" : "fa-envelope"}`}></i>
      </button>
      <button
        className={`${activeButton === "configuracion" ? "active" : ""}`}
        onClick={() => handleButtonClick("configuracion")}
      >
        <span><FaCog /></span>
      </button>   
    </nav>
    </div>
  );
};

export default MenuSuperior;
